const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getRecallReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECALL_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'RECALL_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'RECALL_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'RECALL_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getRecallReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getRecallReport.js